module.exports = __webpack_public_path__ + "img/icn_borchie.a4b2a5d1.svg";